/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Section_EmptyInputs */



/**
* | output |
* | --- |
* | "The material said nothing about this." |
*
* @param {Meeting_Report_Section_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_section_empty = /** @type {((inputs?: Meeting_Report_Section_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Section_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Hier stond niets over in het materiaal.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Il n'y avait rien à ce sujet dans les sources.")
	return /** @type {LocalizedString} */ ("The material said nothing about this.")
});